import React from 'react'
import './ScoreNumber.css'
import { scoreBracket } from '../../utils/score_meta'

export default ({ value, glow, size, onClick, active }) => (
  <div className={`score-number${active? ' active-number' : ''}${glow? ' glow-number' : ''}`} onClick={onClick}>
    <div className={`numerator score-${scoreBracket(value)} score-${size || 'xl'}`}>{value}</div>
    <div className="denominator">/100</div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/ScoreNumber/index.js